import React, { VFC } from 'react';
import styled from 'styled-components';
import T from 'i18n-react';

import LaunchIcon from '@material-ui/icons/Launch';
import InstagramColorIcon from '~/images/logo/sns/instagram_color.png';
import { Image } from '~/models/Instagram/InstagramModel';
import ErrorComponent from './ErrorComponent';
import PcImagesComponent from './PcImagesComponent';
import SPAndTabletImagesComponent from './SPAndTabletImagesComponent';
import CardsLineTitle from '../../../atoms/CardsLineTitle';
import MoreSeeLink from '../../../atoms/MoreSeeLink';
import SimpleCompound from '~/src/core/components/CompoundComponents/SimpleCompound';

const LARGE_BREAK_POINT = 1200;

const Wrapper = styled.div`
  margin: ${({ theme }) => theme.spacing(0, 2.5)};
`;
const IconWrapper = styled.div`
  margin-right: ${({ theme }) => theme.spacing(1)}px;
`;
const ImagesWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(3)}px;
`;
interface Props {
  hasError: boolean;
  images: Image[];
}
const InstagramImageComponent: VFC<Props> = ({ hasError, images }: Props) => {
  const isPC = window.innerWidth >= LARGE_BREAK_POINT;
  const isSPAndTablet = window.innerWidth < LARGE_BREAK_POINT;

  return (
    <Wrapper>
      <CardsLineTitle>
        <IconWrapper>
          <img
            src={InstagramColorIcon}
            alt={T.translate('homes.instagram.icon') as string}
            width="32"
          />
        </IconWrapper>
        {T.translate('homes.instagram.title')}
      </CardsLineTitle>
      <ImagesWrapper>
        <SimpleCompound isShow={hasError}>
          <ErrorComponent />
        </SimpleCompound>
        <SimpleCompound isShow={!hasError && isPC}>
          <PcImagesComponent images={images} />
        </SimpleCompound>
        <SimpleCompound isShow={!hasError && isSPAndTablet}>
          <SPAndTabletImagesComponent images={images} />
        </SimpleCompound>
      </ImagesWrapper>
      <MoreSeeLink
        linkProps={{
          href: process.env.OFFICIAL_INSTAGRAM_URL,
          target: '_blank',
          rel: 'noreferrer',
        }}
        Icon={LaunchIcon}
      >
        {T.translate('seeMore')}
      </MoreSeeLink>
    </Wrapper>
  );
};

export default InstagramImageComponent;
